/* @ngInject */
function brandService ($rootScope, $timeout, BrandBaseService, ConnectorWebService, CONSTANTS, Utils, UploadService, ToastService, MessageService, $translate, BackendErrorParserService) {
  // Regex to check file extension to .png, .jpg, .jpeg
  const _imageFileExtensions = /\.(png|jpeg|jpg)$/i

  const service = {
    batchUnlinkBrandSectionAsset,
    unlinkBrandSectionAsset,
    getBrandSectionTypeOptions,
    getBrandSectionAssetsBySearch,
    getBrandSectionIconByType,
    createBrandSection,
    createBrandSectionCategory,
    createBrandSectionAssets,
    updateBrandSection,
    updateBrandSectionOrder,
    updateBrandSectionAsset,
    updateBrandSectionCategory,
    bulkDeleteBrandSectionAsset,
    bulkDeleteBrandSectionFont,
    deleteBrandSectionCategory,
    downloadBrandSectionAsset,
    isValidImageFileForEditor,
    deletebrandSection,
    getAssetsAndCategoriesCount,
    getCategoriesAssetsCount,
    preventUploadWebp,
    searchBrandFonts,
    attachAssetsToBrandSection
  }
  return angular.extend({}, BrandBaseService, service)

  /**
  * Get assets from brand section
  * @param {Object} options
  * @param {String} options.searchTerm - term to search for assets
  * @param {number} options.top - pagination
  * @param {number} options.skip - pagination
  */
  function getBrandSectionAssetsBySearch (options) {
    var url = Utils.fnAddQueryToUrl(CONSTANTS.URL_ASSETS_SEARCH, { term: options.searchTerm })
    url = Utils.fnAddTopSkipQueriesToUrl(url, options.top, options.skip)

    return ConnectorWebService.get(url).then(BrandBaseService.mapGetResponse)
  }

  function getBrandSectionTypeOptions () {
    return [
      { value: 'LOGO', label: $translate.instant('brand.sectionTypes.LOGO'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true },
      { value: 'COLOR', label: $translate.instant('brand.sectionTypes.COLOR'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true },
      { value: 'BACKGROUND', label: $translate.instant('brand.sectionTypes.BACKGROUND'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true },
      { value: 'ICON', label: $translate.instant('brand.sectionTypes.ICON'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true },
      { value: 'FONT', label: $translate.instant('brand.sectionTypes.FONT'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true },
      { value: 'IMAGE', label: $translate.instant('brand.sectionTypes.IMAGE'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true },
      { value: 'VIDEO', label: $translate.instant('brand.sectionTypes.VIDEO'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true },
      { value: 'TONE_OF_VOICE', label: $translate.instant('brand.sectionTypes.TONE_OF_VOICE'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'TAGLINE', label: $translate.instant('brand.sectionTypes.TAGLINE'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'PURPOSE', label: $translate.instant('brand.sectionTypes.PURPOSE'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'MISSION', label: $translate.instant('brand.sectionTypes.MISSION'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'VISION', label: $translate.instant('brand.sectionTypes.VISION'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'BRAND_ATTRIBUTES', label: $translate.instant('brand.sectionTypes.BRAND_ATTRIBUTES'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'PRODUCT_ATTRIBUTES', label: $translate.instant('brand.sectionTypes.PRODUCT_ATTRIBUTES'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'KEY_PRODUCT_MESSAGES', label: $translate.instant('brand.sectionTypes.KEY_PRODUCT_MESSAGES'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'BRAND_PERSONALITY', label: $translate.instant('brand.sectionTypes.BRAND_PERSONALITY'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'BRAND_VALUE_PROPOSITION', label: $translate.instant('brand.sectionTypes.BRAND_VALUE_PROPOSITION'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'FUNCTIONAL_PRODUCT_BENEFITS', label: $translate.instant('brand.sectionTypes.FUNCTIONAL_PRODUCT_BENEFITS'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'EMOTIONAL_PRODUCT_BENEFITS', label: $translate.instant('brand.sectionTypes.EMOTIONAL_PRODUCT_BENEFITS'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'REASONS_TO_BELIEVE', label: $translate.instant('brand.sectionTypes.REASONS_TO_BELIEVE'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'CUSTOMER_PROFILE', label: $translate.instant('brand.sectionTypes.CUSTOMER_PROFILE'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'BRAND_NAME', label: $translate.instant('brand.sectionTypes.BRAND_NAME'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'BRAND_WEBSITE', label: $translate.instant('brand.sectionTypes.BRAND_WEBSITE'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'REFERENCE_COMPANIES', label: $translate.instant('brand.sectionTypes.REFERENCE_COMPANIES'), allowAiUsage: true, allowAddCategories: false, allowAddFiles: false },
      { value: 'OTHER', label: $translate.instant('brand.sectionTypes.OTHER'), allowAiUsage: false, allowAddCategories: true, allowAddFiles: true }
    ]
  }

  function getBrandSectionIconByType (type) {
    switch (type) {
      case 'LOGO':
        return 'certificate'
      case 'ICON':
        return 'th'
      case 'BACKGROUND':
        return 'chess board'
      case 'IMAGE':
        return 'images'
      case 'COLOR':
        return 'tint'
      case 'FONT':
        return 'font'
      case 'VIDEO':
        return 'video'
      default:
        return 'copy'
    }
  }

  function createBrandSection (brandSection) {
    return ConnectorWebService.post(CONSTANTS.URL_BRAND_SECTIONS, brandSection)
  }

  function createBrandSectionCategory (category) {
    return ConnectorWebService.post(CONSTANTS.URL_BRAND_SECTIONS_CATEGORIES, category)
  }

  function attachAssetsToBrandSection (brandSectionId, assetsId, brandSectionCategoryId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID_ASSETS, [brandSectionId])

    return ConnectorWebService.post(url, { assetsId, brandSectionCategoryId })
  }

  function createBrandSectionAssets (assets, brandSectionId, options, additionalData) {
    if (!assets || !assets.length) {
      return
    }

    $rootScope.uploadingFiles.push(...assets)
    const uploadPromise = UploadService.generateThumbnailInBrowserAndUploadMultipleFiles(assets, {
      onUploadProgress: (file, progress) => {
        $timeout(() => {
          file.percentage = parseInt(progress, 10)
        })
      }
    }).then((createdAssets) => {
      const assetsId = createdAssets.map((asset) => asset.id)

      return attachAssetsToBrandSection(brandSectionId, assetsId, additionalData?.brandSectionCategoryId)
    }).catch((err) => {
      if (err.code === 'ERR_CANCELED') {
        return
      }

      if (BackendErrorParserService.isInvalidFileError(err)) {
        ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
        return
      }

      ToastService.defaultErrorToast()
    })

    if (options.successCallback) {
      uploadPromise.then(options.successCallback)
    }
  }

  function updateBrandSection (sectionId, brandSection) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID, [sectionId])
    return ConnectorWebService.put(url, brandSection)
  }

  function updateBrandSectionOrder (oldOrder, newOrder) {
    return ConnectorWebService.put(CONSTANTS.URL_BRAND_SECTIONS_ORDER, {
      oldOrder,
      newOrder
    })
  }

  function updateBrandSectionAsset (assetId, asset) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_ID, [assetId])
    return ConnectorWebService.put(url, asset)
  }

  function updateBrandSectionCategory (categoryId, category) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_CATEGORIES_ID, [categoryId])
    return ConnectorWebService.put(url, category)
  }

  function unlinkBrandSectionAsset (brandSectionId, assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID_ASSETS_ASSETID, [brandSectionId, assetId])
    return ConnectorWebService.fnDelete(url)
  }

  function batchUnlinkBrandSectionAsset (brandSectionId, assetsId) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID_ASSETS_BATCH, [brandSectionId])
    url = Utils.addQueryStringFromArray(url, 'assetsId', assetsId)

    return ConnectorWebService.fnDelete(url)
  }

  function bulkDeleteBrandSectionAsset (assetsId) {
    return ConnectorWebService.put(CONSTANTS.URL_CUSTOMER_ASSETS_BATCH_DELETE, assetsId)
  }

  function bulkDeleteBrandSectionFont (fontsId) {
    return ConnectorWebService.put(CONSTANTS.URL_FONTS_BATCH_DELETE, fontsId)
  }

  function deleteBrandSectionCategory (categoryId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_CATEGORIES_ID, [categoryId])
    return ConnectorWebService.fnDelete(url)
  }

  function downloadBrandSectionAsset (asset) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [asset.id])
    url = Utils.fnAddQueryToUrl(url, { downloadModule: 'BRAND' })

    Utils.downloadFile(url)
  }

  function isValidImageFileForEditor (fileName) {
    return _imageFileExtensions.test(fileName)
  }

  function deletebrandSection (sectionId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID, [sectionId])
    return ConnectorWebService.fnDelete(url)
  }

  function getAssetsAndCategoriesCount (sectionId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID_COUNT, [sectionId])
    return ConnectorWebService.get(url)
  }

  function getCategoriesAssetsCount (sectionId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_CATEGORIES_ID_COUNT, [sectionId])
    return ConnectorWebService.get(url)
  }

  function preventUploadWebp (assets, section, categoryId, index, showMessage, fnSuccess) {
    const reader = new FileReader()
    reader.onloadend = function (event) {
      const image = event.target.result

      const arr = (new Uint8Array(image)).subarray(0, 4)
      let header = ''
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16)
      }

      if (header === '52494646') { // webp code
        const i = assets.findIndex(a => a === assets[index])
        if (i !== -1) {
          assets.splice(i, 1)
          index--
          showMessage = true
        }
      }

      if (assets.length - 1 > index) {
        preventUploadWebp(assets, section, categoryId, ++index, showMessage, fnSuccess)
      } else {
        if (showMessage) {
          MessageService.warning({
            title: $translate.instant('uploadWebpMessage.title'),
            text: $translate.instant('uploadWebpMessage.text'),
            confirmButton: $translate.instant('ok'),
            closeOnConfirm: true,
            press () {
              createBrandSectionAssets(assets, section.id, { successCallback: fnSuccess.bind(this, { trackEvent: true }) }, { brandSectionCategoryId: categoryId })
            }
          })
        } else {
          createBrandSectionAssets(assets, section.id, { successCallback: fnSuccess.bind(this, { trackEvent: true }) }, { brandSectionCategoryId: categoryId })
        }
      }
    }
    reader.readAsArrayBuffer(assets[index])
  }

  function searchBrandFonts (params) {
    var url = Utils.fnAddQueryToUrl(CONSTANTS.URL_FONTS_BRAND_SEARCH, { term: params.searchTerm })
    url = Utils.fnAddTopSkipQueriesToUrl(url, params.top, params.skip)

    return ConnectorWebService.get(url)
  }
}

export { brandService }
